import React from "react";
import { IKImage } from "imagekitio-next";

type ImageWrapperPropsType = {
  imageName?: string;
  alt: string;
  className?: string;
};

const urlEndpoint = process.env.NEXT_PUBLIC_BASE_IMAGE_KIT_URL_BLOG_IMG;

const MarketingImage = ({ imageName, alt, className = "" }: ImageWrapperPropsType) => {
  return (
    <IKImage
      src={`${urlEndpoint}${imageName}`}
      key={imageName}
      urlEndpoint={urlEndpoint}
      transformation={[{ crop: "maintain_ratio" }]}
      width={450}
      height={600}
      alt={alt}
      lqip={{ active: true, quality: 20 }}
      loading="lazy"
      className={className}
    />
  );
};

export default MarketingImage;
